module.exports = __webpack_public_path__ + "img/nomura.70fa2f4a.jpg";